import { useEffect, useState } from 'react'

import { getIsOrderCreationInProgress } from '../utils'

const useIsOrderCreationInProgress = (): boolean => {
    const [hasPostponedOrder, setHasPostponedOrder] = useState(false)

    useEffect(() => {
        setHasPostponedOrder(getIsOrderCreationInProgress())
    }, [])

    return hasPostponedOrder
}

export { useIsOrderCreationInProgress }
